import { render } from "./SlideShowSettings.vue?vue&type=template&id=23df8198"
import script from "./SlideShowSettings.vue?vue&type=script&lang=js"
export * from "./SlideShowSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__